(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[650],{

/***/ 2917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EchoCard; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88460);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77589);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["title", "children", "style", "className", "extra"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function EchoCard(_ref) {
  let {
    title,
    children,
    style,
    className = '',
    extra
  } = _ref,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  const combinedClassName = Array.isArray(className) ? [(_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().container), ...className] : [(_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().container), className];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    className: combinedClassName,
    title: title ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().title),
      children: title
    }) : null,
    style: _objectSpread({
      borderRadius: '16px',
      padding: '12px'
    }, style),
    extra: extra ? extra : null
  }, props), {}, {
    children: children
  }));
}

/***/ }),

/***/ 30650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ guide; },
  "getServerSideProps": function() { return /* binding */ getServerSideProps; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/pages/guide/index.module.less
var index_module = __webpack_require__(15126);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/EchoCard/index.tsx
var EchoCard = __webpack_require__(2917);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Menu/index.js + 11 modules
var Menu = __webpack_require__(28096);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Space/index.js
var Space = __webpack_require__(77303);
// EXTERNAL MODULE: ./node_modules/react-icons/pi/index.esm.js
var pi_index_esm = __webpack_require__(96225);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./src/utils/useLocale.ts
var useLocale = __webpack_require__(83126);
// EXTERNAL MODULE: ./src/utils/useLang.ts
var useLang = __webpack_require__(877);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/guide/DATA.tsx











const useData = () => {
  const t = (0,useLocale/* default */.Z)();
  const lang = (0,useLang/* default */.Z)();
  const isChina = lang === 'zh-CN';
  return [{
    title: /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* MdOutlineProductionQuantityLimits */.siy, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: t['product_module']
      })]
    }),
    children: [{
      title: t['library.products'],
      path: 'products'
    }, {
      title: t['leaderboard.products.rank'],
      path: 'product-rank'
    }]
  }, {
    title: /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(pi_index_esm/* PiStarThin */.w3$, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: t['influencer_module']
      })]
    }),
    children: [{
      title: t['menu.influencer.library'],
      path: 'influencers'
    }, {
      title: t['leaderboard.influencers.rank'],
      path: 'influencer-rank'
    }]
  }, {
    title: /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(bs_index_esm/* BsShop */.KMp, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: t['shop_module']
      })]
    }),
    children: [{
      title: t['shops.name'],
      path: 'shops'
    }, {
      title: t['leaderboard.shops.rank'],
      path: 'shop-rank'
    }, {
      title: t['detail.shops'],
      path: 'shop-detail'
    }]
  }, {
    title: /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* MdOutlineSlowMotionVideo */.lMP, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: t['video_module']
      })]
    }),
    children: [{
      title: t['video.name'],
      path: 'videos'
    }, {
      title: t['videos.leaderboard.top_videos'],
      path: 'top-videos'
    }]
  }, {
    title: /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ri_index_esm/* RiLiveLine */.Qxy, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: t['live_module']
      })]
    }),
    children: [{
      title: t['live.name'],
      path: 'lives'
    }, {
      title: t['leaderboard.lives.rank'],
      path: 'live-rank'
    }]
  }, {
    title: /*#__PURE__*/(0,jsx_runtime.jsxs)(Space/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaTools */.CP_, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: t['tool_module']
      })]
    }),
    children: [{
      title: t['tools.ai'],
      path: 'ai-tools'
    }, {
      title: t['tool.calculator.name'],
      path: 'fee-calculator'
    }, {
      title: t['monitor_tool'],
      path: 'monitor'
    }, {
      title: t['board.platform.analysis'],
      path: 'browser-extension'
    }]
  }];
};
const useDetailData = () => {
  const t = (0,useLocale/* default */.Z)();
  const lang = (0,useLang/* default */.Z)();
  const isChina = lang === 'zh-CN';
  return [{
    path: 'products',
    title: t['product.name'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/products.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/products_en.mp4',
    description: t['guide.product.desc'],
    link: '/products'
  }, {
    path: 'product-rank',
    title: t['guide.product_rank.title'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/product-rank.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/product-rank_en.mp4',
    description: t['guide.product_rank.desc'],
    link: '/products/leaderboard/top-sold'
  }, {
    path: 'country-market',
    title: t['dashboard_data'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/dashboard.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/dashboard_en.mp4',
    description: t['guide.dashboard.desc'],
    link: '/analysis/country'
  }, {
    path: 'fee-calculator',
    title: t['guide.ai_calculate.title'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/calculator.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/calculator_en.mp4',
    description: t['guide.fee-calculator.desc'],
    link: '/tool/calculator'
  }, {
    path: 'monitor',
    title: t['monitor_tool'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/monitor.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/monitor_en.mp4',
    description: t['monitor.live_video'],
    link: '/live/monitor'
  }, {
    path: 'ai-tools',
    title: t['tools.ai'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/ai.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/ai_en.mp4',
    description: t['guide.tools_ai.desc'],
    link: '/tool/ai'
  }, {
    path: 'top-videos',
    title: t['videos.leaderboard.top_videos'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/videos-rank.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/videos-rank_en.mp4',
    description: t['guide.top_video.desc'],
    link: '/videos/leaderboard/top-videos'
  }, {
    path: 'videos',
    title: t['video.name'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/videos.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/videos_en.mp4',
    description: t['guide.videos.desc'],
    link: '/videos'
  }, {
    path: 'shop-detail',
    title: t['guide.shop.title'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/shop-detail.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/shop-detail_en.mp4',
    description: t['guide.shop.desc']
  }, {
    path: 'influencer-rank',
    title: t['leaderboard.influencers'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/influencer-rank.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/influencer-rank_en.mp4',
    description: t['guide.influncer_rank.desc'],
    link: '/leaderboard/sales-champion'
  }, {
    path: 'live-rank',
    title: t['leaderboard.lives'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/live-rank.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/live-rank_en.mp4',
    description: t['guide.live_rank.desc'],
    link: '/leaderboard/most-viewed'
  }, {
    path: 'lives',
    title: t['live.name'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/lives.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/lives_en.mp4',
    description: t['guide.lives.desc'],
    link: '/live'
  }, {
    path: 'influencers',
    title: t['menu.influencer.library'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/influencers.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/influencers_en.mp4',
    description: t['guide.influencers.desc'],
    link: '/influencers'
  }, {
    path: 'shops',
    title: t['shops.name'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/shops.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/shops_en.mp4',
    description: t['guide.shops.desc'],
    link: '/shops'
  }, {
    path: 'shop-rank',
    title: t['leaderboard.shops'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/shops-rank.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/shops-rank_en.mp4',
    description: t['guide.shop_rank.desc'],
    link: '/shops/leaderboard/local'
  }, {
    path: 'browser-extension',
    title: t['board.platform.analysis'],
    video: isChina ? 'https://echosell-static.tos-cn-beijing.volces.com/guides/brower-extention.mp4' : 'https://echosell-static.tos-cn-beijing.volces.com/guides/brower_plugion.mp4',
    description: t['guide.browser.desc'],
    link: 'https://echotik.live/zh/features/extension'
  }];
};
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/guide/guide-detail/index.module.less
var guide_detail_index_module = __webpack_require__(51615);
var guide_detail_index_module_default = /*#__PURE__*/__webpack_require__.n(guide_detail_index_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/pages/guide/guide-detail/index.tsx






const GuideDetail = _ref => {
  let {
    data
  } = _ref;
  const t = (0,useLocale/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (guide_detail_index_module_default()).video,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("video", {
        src: data.video,
        style: {
          width: 1000,
          height: 560
        },
        controls: true
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (guide_detail_index_module_default()).video,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (guide_detail_index_module_default()).title,
        children: data === null || data === void 0 ? void 0 : data.title
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (guide_detail_index_module_default()).video,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (guide_detail_index_module_default()).description,
        children: [data === null || data === void 0 ? void 0 : data.description, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data.link ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            style: {
              marginLeft: 10
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: data.link,
              children: t['go']
            })
          }) : null
        })]
      })
    })]
  });
};

/* harmony default export */ var guide_detail = (GuideDetail);
// EXTERNAL MODULE: ./src/store/index.ts
var store = __webpack_require__(26638);
// EXTERNAL MODULE: ./src/api/request.ts
var request = __webpack_require__(84425);
// EXTERNAL MODULE: ./src/utils/getServerSidePropsCatch.ts
var getServerSidePropsCatch = __webpack_require__(17648);
;// CONCATENATED MODULE: ./src/pages/guide/index.tsx













const MenuItem = Menu/* default.Item */.Z.Item;
const SubMenu = Menu/* default.SubMenu */.Z.SubMenu;

const Guide = () => {
  const t = (0,useLocale/* default */.Z)();
  const {
    0: selectedKeys,
    1: setSelectedKeys
  } = (0,react.useState)(['products']);
  const details = useDetailData();
  const dataList = useData();
  const router = (0,next_router.useRouter)();
  const currentId = router.query.id;
  const currentData = currentId ? details.find(i => i.path === currentId) : {};
  (0,react.useEffect)(() => {
    if (router.query.id) {
      setSelectedKeys([router.query.id]);
    }
  }, [router.query.id]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).title,
      children: t['product_guide']
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).subtitle,
      children: t['echotik_guide']
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(EchoCard/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default()).nav,
          style: {
            height: 700
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Menu/* default */.Z, {
            hasCollapseButton: false,
            autoOpen: true,
            selectedKeys: selectedKeys,
            style: {
              height: '100%'
            },
            defaultOpenKeys: ['0'],
            defaultSelectedKeys: selectedKeys,
            onClickMenuItem: (key, event, keyPath) => {
              router.push(`/guide/${key}`);
              setSelectedKeys([key]);
            },
            children: dataList.map((item, index) => {
              var _item$children;

              return /*#__PURE__*/(0,jsx_runtime.jsx)(SubMenu, {
                title: item.title,
                children: item === null || item === void 0 ? void 0 : (_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.filter(i => !i.hide).map((child, subIndex) => {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
                    children: child.title
                  }, child.path);
                })
              }, `${index}`);
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default()).component,
          children: router.pathname === '/guide' ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: t['menu_left_guide']
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(guide_detail, {
            data: currentData
          })
        })]
      })
    })]
  });
};

const getServerSideProps = store/* wrapper.getServerSideProps */.Y.getServerSideProps(store => async context => {
  try {
    const ssrCtx = (0,request/* generateSsrCtx */._8)(store.getState());
    return {
      props: {
        ssrCtx
      }
    };
  } catch (error) {
    return (0,getServerSidePropsCatch/* default */.Z)(error);
  }
});
/* harmony default export */ var guide = (Guide);

/***/ }),

/***/ 17648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42586);



const getServerSidePropsCatch = (error, context) => {
  var _error$data6, _error$data6$errors, _error$data7;

  if (axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error)) {
    var _error$response, _context$query;

    const statusCode = String((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status);

    if ((context === null || context === void 0 ? void 0 : (_context$query = context.query) === null || _context$query === void 0 ? void 0 : _context$query.from) === 'monitor') {
      var _error$data, _error$data$errors, _error$data2;

      return {
        props: {
          errorCode: '405',
          message: (error === null || error === void 0 ? void 0 : (_error$data = error.data) === null || _error$data === void 0 ? void 0 : (_error$data$errors = _error$data.errors) === null || _error$data$errors === void 0 ? void 0 : _error$data$errors.messages) || (error === null || error === void 0 ? void 0 : (_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.msg) || (error === null || error === void 0 ? void 0 : error.message) || ''
        }
      };
    }

    if (['403', '404', '500'].includes(statusCode)) {
      var _error$data3, _error$data3$errors, _error$data4;

      return {
        props: {
          errorCode: statusCode,
          message: (error === null || error === void 0 ? void 0 : (_error$data3 = error.data) === null || _error$data3 === void 0 ? void 0 : (_error$data3$errors = _error$data3.errors) === null || _error$data3$errors === void 0 ? void 0 : _error$data3$errors.messages) || (error === null || error === void 0 ? void 0 : (_error$data4 = error.data) === null || _error$data4 === void 0 ? void 0 : _error$data4.msg) || (error === null || error === void 0 ? void 0 : error.message) || ''
        }
      };
    } else if (statusCode === '401') {
      return {
        redirect: {
          destination: `/login`,
          permanent: false
        }
      };
    }
  } else {
    var _error$data5;

    const code = error === null || error === void 0 ? void 0 : (_error$data5 = error.data) === null || _error$data5 === void 0 ? void 0 : _error$data5.code;

    if ([_constants__WEBPACK_IMPORTED_MODULE_1__/* .NOT_VERIFIED */ .MC].includes(code)) {
      return {
        redirect: {
          destination: '/not-verified',
          permanent: false
        }
      };
    }
  }

  return {
    props: {
      errorCode: '500',
      message: (error === null || error === void 0 ? void 0 : (_error$data6 = error.data) === null || _error$data6 === void 0 ? void 0 : (_error$data6$errors = _error$data6.errors) === null || _error$data6$errors === void 0 ? void 0 : _error$data6$errors.messages) || (error === null || error === void 0 ? void 0 : (_error$data7 = error.data) === null || _error$data7 === void 0 ? void 0 : _error$data7.msg) || (error === null || error === void 0 ? void 0 : error.message) || ''
    }
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getServerSidePropsCatch);

/***/ }),

/***/ 877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59544);


/**
 * 获取language
 */

function useLang() {
  const {
    lang
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .GlobalContext */ .kn);
  return lang;
}

/* harmony default export */ __webpack_exports__["Z"] = (useLang);

/***/ }),

/***/ 77589:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__GMNkT","title":"index_title__WaNUH"};

/***/ }),

/***/ 51615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"video":"index_video__YARcW","title":"index_title__xtZ2T","description":"index_description__tfvXG"};

/***/ }),

/***/ 15126:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__DJJHs","subtitle":"index_subtitle__NhoVR","content":"index_content__NJ8XP","component":"index_component__rJLeY"};

/***/ })

}]);